module.exports = __webpack_public_path__ + "img/Collo180_ok.ec533118.png";